export default __webpack_public_path__ + "static/media/359.2b001783.png";